import { apiAxios } from '../../../helpers/api'

export const getListPermissions = async (commit) => {
  const response = await apiAxios.get('permissions/')
  commit('updateList', response.data.data.permissions)
}
export const getUserRolePermissions = async (commit) => {
  const response = await apiAxios.get('userRolePermissions/')
  commit('updateUserRolePermissionsList', response.data.data.userRolePermissions)
}
